<template>
  <el-dialog
    :title="$t('addAttrSpec.add')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="addAttrSpecInfo" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item :label="$t('addAttrSpec.attrTable')" prop="tableName">
        <el-select 
          v-model="addAttrSpecInfo.tableName" 
          :placeholder="$t('addAttrSpec.tableNamePlaceholder')"
          style="width:100%"
        >
          <el-option 
            v-for="item in tableOptions" 
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.domain')" prop="domain">
        <el-input 
          v-model="addAttrSpecInfo.domain" 
          :placeholder="$t('addAttrSpec.domainPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.specName')" prop="specName">
        <el-input 
          v-model="addAttrSpecInfo.specName" 
          :placeholder="$t('addAttrSpec.specNamePlaceholder')"
          maxlength="64"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.specCd')" prop="specCd">
        <el-input 
          v-model="addAttrSpecInfo.specCd" 
          :placeholder="$t('addAttrSpec.specCdPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.description')" prop="specHoldplace">
        <el-input 
          v-model="addAttrSpecInfo.specHoldplace" 
          :placeholder="$t('addAttrSpec.descriptionPlaceholder')"
          maxlength="200"
          show-word-limit
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.required')" prop="required">
        <el-select 
          v-model="addAttrSpecInfo.required" 
          :placeholder="$t('addAttrSpec.requiredPlaceholder')"
          style="width:100%"
        >
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.show')" prop="specShow">
        <el-select 
          v-model="addAttrSpecInfo.specShow" 
          :placeholder="$t('addAttrSpec.showPlaceholder')"
          style="width:100%"
        >
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.valueType')" prop="specValueType">
        <el-select 
          v-model="addAttrSpecInfo.specValueType" 
          :placeholder="$t('addAttrSpec.valueTypePlaceholder')"
          style="width:100%"
        >
          <el-option 
            v-for="item in valueTypeOptions" 
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.specType')" prop="specType">
        <el-select 
          v-model="addAttrSpecInfo.specType" 
          :placeholder="$t('addAttrSpec.specTypePlaceholder')"
          style="width:100%"
        >
          <el-option label="input" value="2233"></el-option>
          <el-option label="select" value="3344"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAttrSpec.queryShow')" prop="listShow">
        <el-select 
          v-model="addAttrSpecInfo.listShow" 
          :placeholder="$t('addAttrSpec.queryShowPlaceholder')"
          style="width:100%"
        >
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAttrSpecInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAttrSpec } from '@/api/dev/attrSpecApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAttrSpec',
  data() {
    return {
      dialogVisible: false,
      addAttrSpecInfo: {
        specCd: '',
        tableName: '',
        specName: '',
        specHoldplace: '',
        required: '',
        specShow: '',
        specValueType: '',
        specType: '',
        listShow: '',
        domain: 'COMMON'
      },
      tableOptions: [
        { value: 'building_room_attr', label: this.$t('addAttrSpec.buildingRoomAttr') },
        { value: 'building_owner_attr', label: this.$t('addAttrSpec.buildingOwnerAttr') },
        { value: 'building_community_attr', label: this.$t('addAttrSpec.buildingCommunityAttr') },
        { value: 'machine_attr', label: this.$t('addAttrSpec.machineAttr') },
        { value: 'parking_area_attr', label: this.$t('addAttrSpec.parkingAreaAttr') },
        { value: 'owner_car_attr', label: this.$t('addAttrSpec.ownerCarAttr') }
      ],
      valueTypeOptions: [
        { value: '1001', label: this.$t('addAttrSpec.string') },
        { value: '2002', label: this.$t('addAttrSpec.integer') },
        { value: '3003', label: this.$t('addAttrSpec.amount') }
      ],
      rules: {
        tableName: [
          { required: true, message: this.$t('addAttrSpec.tableNameRequired'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('addAttrSpec.domainRequired'), trigger: 'blur' }
        ],
        specName: [
          { required: true, message: this.$t('addAttrSpec.specNameRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('addAttrSpec.specNameMaxLength'), trigger: 'blur' }
        ],
        specCd: [
          { required: true, message: this.$t('addAttrSpec.specCdRequired'), trigger: 'blur' }
        ],
        specHoldplace: [
          { required: true, message: this.$t('addAttrSpec.descriptionRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('addAttrSpec.descriptionMaxLength'), trigger: 'blur' }
        ],
        required: [
          { required: true, message: this.$t('addAttrSpec.requiredRequired'), trigger: 'change' }
        ],
        specShow: [
          { required: true, message: this.$t('addAttrSpec.showRequired'), trigger: 'change' }
        ],
        specValueType: [
          { required: true, message: this.$t('addAttrSpec.valueTypeRequired'), trigger: 'change' }
        ],
        specType: [
          { required: true, message: this.$t('addAttrSpec.specTypeRequired'), trigger: 'change' }
        ],
        listShow: [
          { required: true, message: this.$t('addAttrSpec.queryShowRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addAttrSpecInfo = {
        specCd: '',
        tableName: '',
        specName: '',
        specHoldplace: '',
        required: '',
        specShow: '',
        specValueType: '',
        specType: '',
        listShow: '',
        domain: 'COMMON'
      }
    },
    saveAttrSpecInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.addAttrSpecInfo,
            shopId: getShopId()
          }
          saveAttrSpec(params).then(res => {
            console.log(res)
            this.$message.success(this.$t('addAttrSpec.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          }).catch(error => {
            console.error('保存失败:', error)
            this.$message.error(error.message || this.$t('addAttrSpec.saveFailed'))
          })
        }
      })
    }
  }
}
</script>